import styled from 'styled-components';

export const LoadingContainer = styled.div`
  width: 100%;
  height: 105%;
  background: #0a0a0a;
  z-index: 5000;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 98%;
  position: absolute;
`;
